import { defineMessages } from 'react-intl'

export default defineMessages({
  description: {
    id: 'event.description',
    defaultMessage: 'Description',
  },
  dateAndTime: {
    id: 'event.dateAndTime',
    defaultMessage: 'Date and time',
  },
  moreDatesAndTimes: {
    id: 'event.moreDatesAndTimes',
    defaultMessage: 'Show More',
  },
  lessDatesAndTimes: {
    id: 'event.lessDatesAndTimes',
    defaultMessage: 'Show Less',
  },
  soldOut: {
    id: 'event.soldOut',
    defaultMessage: 'Sold Out',
  },
  location: {
    id: 'event.location',
    defaultMessage: 'Location',
  },
  host: {
    id: 'event.host',
    defaultMessage: 'About the host',
  },
  photos: {
    id: 'event.photos',
    defaultMessage: '{numPhotos, plural, one {{numPhotos} Photo} other {{numPhotos} Photos}}',
  },
  morePhotos: {
    id: 'event.morePhotos',
    defaultMessage: '+ {count} more',
  },
  interests: {
    id: 'event.interests',
    defaultMessage: 'Interests',
  },
  availability: {
    id: 'event.availability',
    defaultMessage: 'Availability',
  },
  showMore: {
    id: 'event.descriptionExpand',
    defaultMessage: 'Show More',
  },
  showLess: {
    id: 'event.descriptionCollapse',
    defaultMessage: 'Show Less',
  },
  getDirections: {
    id: 'event.getDirections',
    defaultMessage: 'Get Directions',
  },
  contactHost: {
    id: 'event.contactHost',
    defaultMessage: 'Contact Host',
  },
  hostImgAlt: {
    id: 'event.hostImgAlt',
    defaultMessage: 'One of our special hosts',
  },
  socialShare: {
    id: 'event.socialShare',
    defaultMessage: 'Share',
  },
  shareToTwitter: {
    id: 'event.shareToTwitter',
    defaultMessage: 'Can\'t wait to go to {listingTitle}! To join me, grab your tickets',
  },
  reportEvent: {
    id: 'event.report',
    defaultMessage: 'Report Event',
  },
  reportEventMessage: {
    id: 'event.reportMessage',
    defaultMessage: 'Event has been flagged for review',
  },
  price: {
    id: 'event.price',
    defaultMessage: 'Price',
  },
  browseEvents: {
    id: 'event.browseEvents',
    defaultMessage: 'Browse other events',
  },
  eventSoldOut: {
    id: 'event.eventSoldOut',
    defaultMessage: 'Sold Out',
  },
  eventUnavailable: {
    id: 'event.eventUnavailable',
    defaultMessage: 'Not Available',
  },
  eventUnavailableGeofenced: {
    id: 'event.eventUnavailableGeofenced',
    defaultMessage: 'Not Available In Your Location',
  },
  eventEnded: {
    id: 'event.eventEnded',
    defaultMessage: 'Sales Ended',
  },
  multipleTimeslots: {
    id: 'eventCard.multipleTimeshots',
    defaultMessage: 'Multiple dates/times',
  },
  seeDetails: {
    id: 'eventCard.seeDetails',
    defaultMessage: 'See Details',
  },
  eventManager: {
    id: 'eventCard.eventManager',
    defaultMessage: 'Event Manager',
  },
  getTickets: {
    id: 'buybutton.get-tickets',
    defaultMessage: 'Get Tickets',
  },
  register: {
    id: 'buybutton.register',
    defaultMessage: 'Register',
  },
  rsvp: {
    id: 'buybutton.rsvp',
    defaultMessage: 'RSVP',
  },
  donate: {
    id: 'buybutton.donate',
    defaultMessage: 'Donate',
  },
  seeDates: {
    id: 'buybutton.see-dates',
    defaultMessage: 'See Dates',
  },
  details: {
    id: 'buybutton.details',
    defaultMessage: 'Details',
  },
  joinWaitlist: {
    id: 'buybutton.joinWaitlist',
    defaultMessage: 'Join Waitlist',
  },
  virtualEvent: {
    id: 'event.virtualEvent',
    defaultMessage: 'Virtual event',
  },
})
